<a [href]="logo?.link" class="py-3.5 block h-full smd:mr-8" [attr.aria-label]="logo?.title">
  <mat-icon [svgIcon]="'site-logo'" class="h-[32px] smd:h-[52px] w-auto text-main-color overflow-visible"></mat-icon>
  <span class="hidden">{{ logo?.title }}</span>
</a>
